import React, { useState, useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Navbar = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const [activeLink, setActiveLink] = useState('Home');
  const [menuOpen, setMenuOpen] = useState(false);
 

  const links = ['Home', 'About', 'Work','Certificates', 'Contact'];

  const handleClick = (link) => {
    setActiveLink(link);
    document.getElementById(link.toLowerCase()).scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };


  return (
    <nav className="ml-4 mr-10 ">
      <div className="container mx-auto flex items-center justify-between">
        <div className='ml-4' data-aos="zoom-in">
          <svg className='h-20 w-40' xmlns="http://www.w3.org/2000/svg">
            <g>
              <ellipse cx="60" cy="40" rx="60" ry="30" width="50" height="50" stroke='#5B5D60' fill="#242424"></ellipse>
              <text x="25" y="50" font-family="Imperial Script" font-size="50" fill="white">Siri</text>
            </g>
          </svg>
        </div>
        <div className="hidden md:flex space-x-8 text-xl text-white" data-aos="fade-left">
          {links.map((link) => (
            <li key={link} className="relative list-none">
              <button
                className={`focus:outline-none ${activeLink === link ? 'font-bold' : ''}`}
                onClick={() => handleClick(link)}
              >
                {link}
              </button>
              {activeLink === link && (
                <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-2 w-2 h-2 bg-[#E4B379] rounded-full"></div>
              )}
            </li>
          ))}
          <a href='https://drive.google.com/file/d/1gFcsHlZdlHtw7ykG2uDTRMfc08ZllRcj/view?usp=sharing' target='/blank'><button className='hover:font-bold'>
            Resume
          </button></a>
        </div>
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="focus:outline-none text-white text-2xl"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden flex flex-col items-center text-xl text-white mt-4 space-y-4" data-aos="fade-down">
          {links.map((link) => (
            <button
              key={link}
              className={`focus:outline-none ${activeLink === link ? 'font-bold' : ''}`}
              onClick={() => handleClick(link)}
            >
              {link}
              {activeLink === link && (
                <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-2 w-2 h-2 bg-[#E4B379] rounded-full"></div>
              )}
            </button>
          ))}
          <a href='https://drive.google.com/file/d/1gFcsHlZdlHtw7ykG2uDTRMfc08ZllRcj/view?usp=sharing' target='/blank'><button className='hover:font-bold'>
            Resume 
          </button></a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
